import { render, staticRenderFns } from "./thirdOrderDetail.vue?vue&type=template&id=a84b82dc&scoped=true"
import script from "./thirdOrderDetail.vue?vue&type=script&lang=js"
export * from "./thirdOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./thirdOrderDetail.vue?vue&type=style&index=0&id=a84b82dc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84b82dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a84b82dc')) {
      api.createRecord('a84b82dc', component.options)
    } else {
      api.reload('a84b82dc', component.options)
    }
    module.hot.accept("./thirdOrderDetail.vue?vue&type=template&id=a84b82dc&scoped=true", function () {
      api.rerender('a84b82dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/thirdOrder/thirdOrderDetail.vue"
export default component.exports